export const API_DATE_FORMAT = 'DD/MM/YYYY'
export const VUETIFY_DATE_FORMAT = 'YYYY-MM-DD'
export const HUMAN_READABLE_DATE_FORMAT = 'D [de] MMMM [de] YYYY'

export const ACTION_STATUS = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
}

export const DEFAULT_CALIFICACION_EVALUACION_DESEMPEÑO = 1
